export const selectOptionsLoanPurposeQuickApp = [
  { label: "Purchase", value: "Purchase" },
  { label: "Refi - Cash Out", value: "Refinance - Cash Out" },
  {
    label: "Refi - No Cash Out (Rate & Term)",
    value: "Refinance - No Cash Out",
  },
];
